<template>
  <div class="content-block content-block--separated">
    <h2 class="mb-6 text-center">
      How it Works?
    </h2>
    <v-row
      wrap
      class="work-steps"
    >
      <v-col
        v-for="(workStep, idx) in workSteps"
        :key="idx"
        class="d-flex"
        cols="12"
        sm="6"
      >
        <div
          class="work-step elevation-2"
          :class="{'active': idx === 0}"
        >
          <div class="work-step__img">
            <img
              :src="require(`@/assets/svg/workSteps/${workStep.icon}.svg`)"
              alt=""
            >
          </div>
          <div class="work-step__content">
            <div class="work-step__title">
              {{ workStep.title }}
            </div>
            <p>{{ workStep.text }}</p>
          </div>
          <div class="work-step__num">
            0{{ idx + 1 }}
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'

@Component({})

export default class HowItWorks extends Vue {
  workSteps = [{
    icon: 'lease',
    title: 'Select your lease period',
    text: 'Select the leasing period that best fits your schedule',
  }, {
    icon: 'house',
    title: 'Pick your unit, room, and lease preferences',
    text: 'Create and customize your lease with your selections',
  }, {
    icon: 'contract',
    title: 'Sign and pay',
    text: 'Complete all forms, contracts, and payments online',
  }, {
    icon: 'key',
    title: 'Quick online approvals',
    text: 'Fast feedback, support, and lease approval',
  }]
}
</script>

<style lang="scss">
  @import "@/assets/styles/variables.scss";

  .work-steps {
    max-width: 60rem;
    margin: 3.75rem auto 0;

    .work-step {
      padding: 1.625rem;
      position: relative;
      width: 100%;
      &__img {
        display: block;
        margin-bottom: 0.75rem;
      }
      &__title {
        font-size: 1.125rem;
        font-weight: 500;
      }
      &__content {
        p {
          color: var(--v-textSecondary-base);
        }
      }
      &__num {
        font-family: $headers-font;
        font-style: normal;
        font-weight: 800;
        font-size: 2.25rem;
        opacity: 0.2;
        position: absolute;
        top: 1.25rem;
        right: 1.625rem;
      }

      &.active {
        .work-step__num {
          color: var(--v-primary-base);
        }
        .work-step__img {
          img {
            filter: invert(42%) sepia(52%) saturate(1068%) hue-rotate(194deg) brightness(101%) contrast(102%);
          }
        }
      }
    }
  }
</style>
